import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    addEventListener('turbo:before-fetch-request', async (event) => {

      // when link for calendar cvs export is clicked
      if(event.detail.url.pathname == '/all_shifts/export') {
        event.preventDefault()

        // pull date from last calendar day and add it to the url
        const dayEl = document.querySelector('.calendar-header .calendar-day:last-of-type')
        if(dayEl) {
          const ends_on = dayEl.getAttribute('data-date')
          event.detail.url.searchParams.set('ends_on', ends_on)
        }

        // check if filtered by users and if so pass user ids to export modal by adding them to the url
        const qUserNameEl = document.querySelector('#q_user_name')
        if(qUserNameEl && qUserNameEl.value) {
          const userRowEls = document.querySelectorAll('.calendar-row[data-user-id]')

          let user_ids = []
          userRowEls.forEach((userRowEl) => {
            user_ids.push(userRowEl.getAttribute('data-user-id'))
          })

          user_ids.map((el, _i) => event.detail.url.searchParams.append('user_ids[]', el))
        }

        event.detail.resume()
      }
    })
  }
}
